<template>
  <div class="h-100" style="min-height: 1px">
    <b-overlay class="h-100" :show="loading" :blur="null" opacity="0">
      <transition name="fadeDownShort" mode="out-in">
        <div v-if="!loading" v-bar class="bar-out">
          <div>
            <div v-if="!data || data.length == 0" class="text-center my-3">
              <div class="mb-3">
                <b-icon icon="question-diamond" font-scale="5" />
              </div>
              <h2 class="mb-3">Žiadne dáta</h2>
            </div>
            <template v-else>
              <component
                :is="type + 'View'"
                v-if="type"
                ref="consumerView"
                :data="data"
                :chart-data="chartData"
                :note="note"
                :report="report"
                @onNoteChange="editNote"
              />
            </template>
          </div>
        </div>
      </transition>
    </b-overlay>
  </div>
</template>
<script>
import PowerView from '../consumer/power/View'
import GasView from '../consumer/gas/View'
import WaterView from '../consumer/water/View'
import HeatView from '../consumer/heat/View'

export default {
  components: {
    PowerView,
    GasView,
    WaterView,
    HeatView,
  },
  data() {
    return {
      loading: false,
      type: this.$store.getters['energetic/getCurrentType'],
      data: [],
      chartData: [],
      report: {},
      note: null,
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    this.$root.$on('reloadConsumerReportData', this.fetchData)
  },
  beforeDestroy() {
    this.$root.$off('reloadConsumerReportData')
  },
  methods: {
    fetchData(silent = false) {
      this.loading = !silent
      this.axios
        .all([
          this.$api.get(
            `reports/${this.$route.params.energetics_id}/consumer/get_report`,
            {
              params: {
                year: this.$route.query.year,
                orderBy: 'reportDate',
              },
            },
          ),
          this.$api.get(
            `reports/${this.$route.params.energetics_id}/consumer/get_summary`,
            {
              params: {
                year: this.$route.query.year,
              },
            },
          ),
          this.$api.get(
            `reports/${this.$route.params.energetics_id}/consumer/get_note`,
            {
              params: {
                year: this.$route.query.year,
              },
            },
          ),
          this.$api.get(
            `reports/${this.$route.params.energetics_id}/consumer/get_monthly_data`,
          ),
        ])
        .then(
          this.axios.spread((report, summary, note, chart) => {
            if (report.data.data) {
              this.data = report.data.data
              this.chartData = chart.data.data
            }
            this.report = summary.data.data
            this.note = note.data.data
            if (!silent) {
              this.loading = false
            }
          }),
        )
    },
    editNote(val) {
      this.$api
        .post('reports/save_note', {
          energetics_id: this.$route.params.energetics_id,
          year: this.$route.query.year,
          note: val,
        })
        .then((res) => {
          this.$refs.consumerView.noteSaved = res.data.success
        })
    },
    remove(id) {
      this.$swal({
        title: 'Ste si istý?',
        text: 'Naozaj chcete odstrániť tieto hodnoty?',
        type: 'info',
        position: 'top',
        showConfirmButton: true,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$api.post(`reports/${id}/remove_consumer`).then((res) => {
            this.$swal({
              type: 'success',
              position: 'top',
              showCloseButton: true,
              text: res.data.message,
              timer: 5000,
            })
            this.fetchData()
          })
        }
      })
    },
  },
}
</script>
